import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.5 3.75H5.75a2 2 0 00-2 2v14a2 2 0 002 2h12.5a2 2 0 002-2v-14a2 2 0 00-2-2H17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 6.75h5.5m-5.5 3h4m.75 12h4a2.498 2.498 0 002.5-2.5m0 0a2.46 2.46 0 00-.732-1.75 2.518 2.518 0 00-1.768-.75h-1V2.25h1a2.5 2.5 0 012.5 2.5v14.5z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.5 3.75H5.75a2 2 0 00-2 2v14a2 2 0 002 2h12.5a2 2 0 002-2v-14a2 2 0 00-2-2H17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 6.75h5.5m-5.5 3h4m.75 12h4a2.498 2.498 0 002.5-2.5m0 0a2.46 2.46 0 00-.732-1.75 2.518 2.518 0 00-1.768-.75h-1V2.25h1a2.5 2.5 0 012.5 2.5v14.5z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23 7.5H11.5a4 4 0 00-4 4v28a4 4 0 004 4h25a4 4 0 004-4v-28a4 4 0 00-4-4H34"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M12 13.5h11m-11 6h8m1.5 24h8a4.995 4.995 0 005-5m0 0a4.918 4.918 0 00-1.465-3.5c-.937-.938-2.209-1.5-3.535-1.5h-2v-29h2a5 5 0 015 5v29z"
  }))
};
export var Journal = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});